export const SET_SELECTED_CARD_ITEM =
  'AUDIT_MISSION/CREATE/SET_SELECTED_CARD_ITEM'
export const SET_SELECTED_CARDS = 'AUDIT_MISSION/CREATE/SET_SELECTED_CARDS'
export const FLUSH_FORM = 'AUDIT_MISSION/CREATE/FLUSH_FORM'
export const SET_FORM = 'AUDIT_MISSION/CREATE/SET_FORM'
